import React, { useState } from "react";
import S from "./Tooltip.styled";
const Tooltip = ({ content, children, delay }) => {
    const [active, setActive] = useState(false);
    const users = [...content.values()].map((user) => user.name).join(", ");
    return (React.createElement(S.TooltipWrapper, { onMouseEnter: () => setActive(true), onMouseLeave: () => setActive(false) },
        children,
        active && React.createElement(S.TooltipTip, null, users)));
};
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map